export const DESKTOP_OR_LAPTOP = 'DESKTOP_OR_LAPTOP'; // {minWidth:1224},
export const IPAD_OR_TABLET = 'IPAD_OR_TABLET'; //{maxWidth:1224, minWidth:850},
export const MOBILE_OR_SIMILAR = 'MOBILE_OR_SIMILAR'; //{maxWidth:850}
export const DEFAULT = 'DEFAULT'; //Uncertain
